import React from 'react';
import PropTypes from 'prop-types';
import {
  Glossary,
  GlossaryHeader,
  GlossaryBody,
  GlossaryRow,
  GlossaryConcept,
  GlossaryDescription,
} from '../../NodeContentPreview/styles';
import { ViewSection } from '../styles';

const GlossaryContentTeacherPanel = ({ data }) => {
  return (
    <>
      <ViewSection>
        <Glossary>
          <GlossaryHeader>
            <GlossaryConcept>{i18n.__('correlation_term')}</GlossaryConcept>
            <GlossaryDescription>{i18n.__('correlation_description')}</GlossaryDescription>
          </GlossaryHeader>
          <GlossaryBody>
            {(data?.CorrelationList?.Concepts || []).map((concept, index) => (
              <GlossaryRow key={concept.id} even={index % 2}>
                <GlossaryConcept dangerouslySetInnerHTML={{ __html: concept.body }} />
                <GlossaryDescription dangerouslySetInnerHTML={{ __html: concept.Description.body }} />
              </GlossaryRow>
            ))}
          </GlossaryBody>
        </Glossary>
      </ViewSection>
    </>
  );
};

export default GlossaryContentTeacherPanel;

GlossaryContentTeacherPanel.propTypes = {
  data: PropTypes.object.isRequired,
};
